document.addEventListener('DOMContentLoaded', () => {
  const title = document.querySelector('.comparison__title');
  const container = document.querySelector('.comparison__container');
  const arrowLeft = document.querySelector('.comparison__arrow_left');
  const arrowRight = document.querySelector('.comparison__arrow_right');
  const content = document.querySelector('.comparison__content');

  // アコーディオンの開閉処理
  title.addEventListener('click', () => {
    const is_active = title.classList.toggle('active');

    if (is_active) {
      container.classList.remove('hide');
      requestAnimationFrame(() => {
        container.classList.add('show');
      });
    } else {
      container.classList.remove('show');
      
      container.addEventListener('transitionend', function handler() {
        if (!container.classList.contains('show')) {
          container.classList.add('hide');
        }
        container.removeEventListener('transitionend', handler);
      });
    }
  });

  // 👇 ここから追加するコード

  // 初期状態で左矢印を非表示にする
  arrowLeft.style.display = 'none';

  // 右矢印のクリックイベント
  arrowRight.addEventListener('click', () => {
    const maxScrollLeft = content.scrollWidth - content.clientWidth;
    content.scrollTo({
      left: maxScrollLeft,
      behavior: 'smooth'
    });
  });

  // 左矢印のクリックイベント
  arrowLeft.addEventListener('click', () => {
    content.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  });

  // スクロールイベントを監視して矢印の表示を切り替える
  content.addEventListener('scroll', () => {
    const isAtRight = content.scrollWidth - content.clientWidth - content.scrollLeft < 1;
    const isAtLeft = content.scrollLeft < 1;

    if (isAtRight) {
      arrowRight.style.display = 'none';
      arrowLeft.style.display = 'block';
    } else if (isAtLeft) {
      arrowLeft.style.display = 'none';
      arrowRight.style.display = 'block';
    } else {
      arrowLeft.style.display = 'block';
      arrowRight.style.display = 'block';
    }
  });

});